<template>
    <div class="report-single">
        <div class="user clearAfterFloats">
            <div class="text-center">
                <img :src="report.User.ProfileUrl" alt="">
            </div>
            <div>
                <p>{{ report.User.Name }}</p>
            </div>
        </div>
        <div class="comment">
            <p class="comment-header">Komentar:</p>
            <p>{{ report.Text }}</p>
        </div>
        <div class="divider"></div>
    </div>
</template>

<script>
export default {
  props: ["report"],
};
</script>

<style scoped>
.report-single{
    padding: 20px;
}
.user {
  position: relative;
}
.user div {
  float: left;
}
.user img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.user div:nth-child(2) p {
    line-height: 50px;
    margin: 0;
    vertical-align: top;
    font-size: 18px;
    font-weight: 400;
}
.comment-header{
    font-style: italic;
    font-weight: 500;
}
.comment p{
    margin: 5px;
}
.divider{
    width: 100%;
    height: 1px;
    margin: 8px 0;
    background-color: #657786;
    border-radius: 20px;
}
</style>
